/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropruletypelisting3Inputs */

const en_dropruletypelisting3 = /** @type {(inputs: Dropruletypelisting3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Follows the linked place`)
};

const de_dropruletypelisting3 = /** @type {(inputs: Dropruletypelisting3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Folgt dem verknüpften Ort`)
};

/**
* | output |
* | --- |
* | "Follows the linked place" |
*
* @param {Dropruletypelisting3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropruletypelisting3 = /** @type {((inputs?: Dropruletypelisting3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropruletypelisting3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropruletypelisting3(inputs)
	return de_dropruletypelisting3(inputs)
});
export { dropruletypelisting3 as "dropRuleTypeListing" }